import { useState } from 'react'

import {
  toggleGroupContext,
  useCreateToggleGroupContext,
  useToggleGroupContext,
} from '@/hooks/providers/ToggleGroupProvider.context'

type ChildrenWithAsFunction =
  React.ReactNode | ((context: ReturnType<typeof useToggleGroupContext>) => React.ReactNode)

export type ToggleGroupProviderProps = {
  initialValue?: string
  children: ChildrenWithAsFunction
}

export const ToggleGroupProvider: React.FC<ToggleGroupProviderProps> = ({
  initialValue,
  children,
}) => {
  const [_initialValue] = useState(initialValue)
  const context = useCreateToggleGroupContext(_initialValue)
  return (
    <toggleGroupContext.Provider value={context}>
      {typeof children === 'function' ? children(context) : children}
    </toggleGroupContext.Provider>
  )
}
